import { useTranslation } from 'react-i18next';
import { useNotification } from '../hooks/useNotification';
import axios from 'axios';
import { useDataAuth } from './useDataAuth';

export const useApiResolver = () => {
    const { t } = useTranslation();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();

    const resolveValue = async (apiCall, showMsg = true, msg = null, msgError = null) => {
        try {
            let errorCode = false;
            const response = await axios.request(apiCall);
            if (response.status === 200) {
                errorCode = response.data?.responseMesaggeType === 'error'
                if (response.data && response.data?.responseMesagge)
                    sendNotification({ msg: response.data.responseMesagge, variant: response.data?.responseMesaggeType || 'success' });
                else {
                    if (showMsg)
                        sendNotification({ msg: msg || t("messages.saveSuccess"), variant: 'success' });
                }

                return {
                    data: response.data,
                    status: response.status,
                    success: true,
                    errorCode
                };
            }
            else if (response.status === 504 || response.status === 408) {
                sendNotification({ msg: msg || t("messages.processRunning"), variant: 'info' });
                return {
                    data: response?.data || null,
                    status: response.status,
                    success: false,
                    errorCode
                };
            }

            if (response.data && response.data?.responseMesagge)
                sendNotification({ msg: response.data.responseMesagge, variant: response.data?.responseMesaggeType || 'error' });
            else
                sendNotification({ msg: msgError || t("messages.errorGeneralAlert"), variant: 'error' });

            return {
                data: response?.data || null,
                status: response.status,
                success: false,
                errorCode
            };
        } catch (error) {
            const statusCode = error.response ? error.response.status : 500;
            if (error.response?.status === 504)
                sendNotification({ msg: msg || t("messages.processRunning"), variant: 'info' });
            else
                sendNotification({ msg: msgError || t("messages.errorGeneralAlert"), variant: 'error' });

            return {
                data: error.response?.data || null,
                status: statusCode,
                success: false,
                errorCode: false
            };
        }
    };

    return { resolveValue };
};